<template>
  <div class="report-fs">
    <!-- <div style="text-align: end; margin-bottom: -175px;">
      <img  class="wlogo" :src="pathLogo" />
     </div> -->
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

    <h3 class="text-center fs-head-co">{{ name }}</h3>
    <h3 class="text-center fs-head-co">{{ desc }}</h3>
    <h3 class="text-center fs-head">تقرير قوائم الموظفين</h3>
    <h3 class="text-center fs-head">{{ data[0].departmentName }}</h3>

    <h4 class="text-left" style="margin-left: 50px; direction: ltr">
      التاريخ : {{ convertToUi(new Date()) }}
    </h4>
    <md-card-content dir="rtl" class="redirect-dir">
      <!-- <md-table class="font-size-style">
        <md-table-row class="font-size-head-style">
          <md-table-head md-numeric>ر.ت</md-table-head>
          <md-table-head class="text-center">الإسم</md-table-head>
          <md-table-head class="text-center">رقم الملف الشخصي</md-table-head>
          <md-table-head class="text-center">الرقم الوطني</md-table-head>
          <md-table-head class="text-center">الادارة</md-table-head>
          <md-table-head class="text-center">الصفة الوظيفية</md-table-head>
          <md-table-head class="text-center">تاريخ الميلاد</md-table-head>
        </md-table-row>

        <md-table-row v-for="(item, i) in data" :key="i">
          <md-table-cell md-numeric>{{ item.num }}</md-table-cell>
          <md-table-cell> {{ item.fullName }}</md-table-cell>
          <md-table-cell> {{ item.profileNumber }}</md-table-cell>
          <md-table-cell>{{ item.nationalNumber }}</md-table-cell>
          <md-table-cell> {{ item.departmentName }}</md-table-cell>
          <md-table-cell> {{ item.jobTitle }}</md-table-cell>
          <md-table-cell>{{ convert(item.birthDate) }}</md-table-cell>
        </md-table-row>
      </md-table> -->

      <md-table
        :value="data"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
        :md-sort-fn="customSort"
        class="staffList paginated-table custome-paginated-table table-striped table-hover mt-25 font-size-style"
      >
        <md-table-row
          class="font-size-style-row"
          slot="md-table-row"
          slot-scope="{ item }"
        >
          <md-table-cell class="border-staffLists" md-label="ر.ت">
            <p>{{ item.num }}</p>
          </md-table-cell>

          <md-table-cell class="w-300 border-staffLists" md-label="الإسم">
            <p>
              {{ item.fullName }}
            </p>
          </md-table-cell>

          <md-table-cell class="border-staffLists" md-label="رقم الموظف">
            <p>
              {{ item.jobNumber }}
            </p>
          </md-table-cell>

          <md-table-cell class="border-staffLists" md-label="الرقم الوطني">
            <p>
              {{ item.nationalNumber }}
            </p>
          </md-table-cell>

          <md-table-cell class="w-400 border-staffLists" md-label="الادارة">
            <p>
              {{ item.departmentName }}
            </p>
          </md-table-cell>
          <md-table-cell
            class="w-300 border-staffLists"
            md-label="الصفة الوظيفية"
          >
            <p>
              {{ item.jobTitle }}
            </p>
          </md-table-cell>

          <md-table-cell
            class="w-200 border-staffLists"
            md-label="الحالة الوظيفية"
          >
            <p>
              {{ item.currentSituationString }}
            </p>
          </md-table-cell>

          <md-table-cell
            class="w-100 border-staffLists"
            md-label="المؤهل العلمي"
          >
            <p>
              {{ item.scientificDegreeName }}
            </p>
          </md-table-cell>

          <md-table-cell class="w-100 border-staffLists" md-label="الدرجة ">
            <p>
              {{ item.currentGrade }}
            </p>
          </md-table-cell>

          <md-table-cell class="w-100 border-staffLists" md-label="العلاوة">
            <p>
              {{ item.currentBonus }}
            </p>
          </md-table-cell>

          <md-table-cell></md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  mounted() {
    //  alert(this.col_d);
  },
  props: ["name", "desc", "data", "pathLogo", "col_d"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/font-size-reset";

.report-fs {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }
  .md-table-head {
    .md-table-head-container {
      .md-table-head-label {
        font-size: 22px !important;
      }
    }
  }
  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }
  .fs-head {
    font-size: 25px !important;
  }
}
</style>